import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  getSmsResendCooldown,
  startSmsResendCooldown,
} from './smsResendCooldown';

export default class SmsResendControl extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onResendSmsCode: PropTypes.func,
    resendCooldownKey: PropTypes.string,
  };

  state = {
    resendDisabledUntil: getSmsResendCooldown(this.props.resendCooldownKey),
    resendInProgress: false,
  };

  _cooldownTimer = null;
  _isMounted = false;
  _resendInProgress = false;

  componentDidMount() {
    this._isMounted = true;
    if (Date.now() < this.state.resendDisabledUntil) {
      this.startCooldownTimer();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this._resendInProgress = false;
    if (this._cooldownTimer) {
      clearInterval(this._cooldownTimer);
    }
  }

  startCooldownTimer = () => {
    if (this._cooldownTimer) {
      return;
    }

    this._cooldownTimer = setInterval(() => {
      if (Date.now() >= this.state.resendDisabledUntil) {
        clearInterval(this._cooldownTimer);
        this._cooldownTimer = null;
        this.forceUpdate();
      }
    }, 1000);
  };

  startResendCooldown = () => {
    const disabledUntil = startSmsResendCooldown(this.props.resendCooldownKey);
    this._resendInProgress = false;
    if (!this._isMounted) {
      return;
    }

    this.setState({
      resendDisabledUntil: disabledUntil,
      resendInProgress: false,
    }, this.startCooldownTimer);
  };

  finishResendAttempt = () => {
    this._resendInProgress = false;
    if (!this._isMounted) {
      return;
    }

    this.setState({ resendInProgress: false });
  };

  countAndResendSmsCode = () => {
    const { onResendSmsCode } = this.props;
    if (!onResendSmsCode) {
      return;
    }

    this._resendInProgress = true;
    this.setState({ resendInProgress: true });
    onResendSmsCode({
      onSuccess: this.startResendCooldown,
      onError: this.finishResendAttempt,
    });
  };

  handleResendClick = event => {
    event.preventDefault();
    const persistedDisabledUntil = getSmsResendCooldown(this.props.resendCooldownKey);
    const { resendDisabledUntil, resendInProgress } = this.state;
    const disabledUntil = Math.max(resendDisabledUntil, persistedDisabledUntil);

    if (resendInProgress || this._resendInProgress || Date.now() < disabledUntil) {
      if (disabledUntil !== resendDisabledUntil) {
        this.setState({ resendDisabledUntil: disabledUntil }, this.startCooldownTimer);
      }
      return;
    }

    this.countAndResendSmsCode();
  };

  render() {
    const { onResendSmsCode, t } = this.props;
    if (!onResendSmsCode) {
      return null;
    }

    const { resendDisabledUntil, resendInProgress } = this.state;
    const resendDisabled = resendInProgress || Date.now() < resendDisabledUntil;

    return (
      <span>
        <button
          type="button"
          onClick={this.handleResendClick}
          disabled={resendDisabled}
          aria-disabled={resendDisabled}
          style={{
            background: 'none',
            border: 0,
            color: '#1890ff',
            cursor: resendDisabled ? 'not-allowed' : 'pointer',
            font: 'inherit',
            opacity: resendDisabled ? 0.5 : 1,
            padding: 0,
          }}
        >
          {t('preposlať SMS kód')}
        </button>
        <br />
        <span style={{ fontSize: '12px', color: '#888' }}>
          {t('Nový SMS kód si môžete vyžiadať raz za 5 minút.')}
        </span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/modals/SmsResendControl.js